export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.66667 7.83325C5.19391 7.83325 4 9.02716 4 10.4999V25.4999C4 26.9727 5.19391 28.1666 6.66667 28.1666H8.40001C8.56512 27.3532 9.02638 26.6474 9.66634 26.1666H6.66667C6.29848 26.1666 6 25.8681 6 25.4999V10.4999C6 10.1317 6.29848 9.83325 6.66667 9.83325H23.3333C23.7015 9.83325 24 10.1317 24 10.4999V26.1666H13.667C14.307 26.6474 14.7682 27.3532 14.9333 28.1666H25H26V27.1666V10.4999C26 9.02716 24.8061 7.83325 23.3333 7.83325H6.66667Z"
                fill="white"
            />
            <circle cx="11.6667" cy="28.8333" r="3.33333" stroke="white" strokeWidth="2" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25 14.5H24V15.5V27.1667V28.1667H25H26.7333C26.8984 27.3533 27.3597 26.6475 27.9997 26.1667H26V16.5H30.9763C31.1531 16.5 31.3227 16.5702 31.4477 16.6953L35.4714 20.719C35.5964 20.844 35.6667 21.0135 35.6667 21.1904V25.5C35.6667 25.8682 35.3682 26.1667 35 26.1667H32.0003C32.6403 26.6475 33.1016 27.3533 33.2667 28.1667H35C36.4728 28.1667 37.6667 26.9728 37.6667 25.5V21.1904C37.6667 20.4831 37.3857 19.8048 36.8856 19.3047L32.8619 15.281C32.3618 14.781 31.6836 14.5 30.9763 14.5H25Z"
                fill="white"
            />
            <circle cx="30" cy="28.8333" r="3.33333" stroke="white" strokeWidth="2" />
        </svg>
    );
}
